var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48438 3.81814C4.48438 2.80551 4.88664 1.83435 5.60268 1.11831C6.31872 0.402267 7.28988 0 8.30251 0C9.31515 0 10.2863 0.402267 11.0023 1.11831C11.7184 1.83435 12.1207 2.80551 12.1207 3.81814V13.9998C12.1207 15.0125 11.7184 15.9836 11.0023 16.6997C10.2863 17.4157 9.31515 17.818 8.30251 17.818C7.28988 17.818 6.31872 17.4157 5.60268 16.6997C4.88664 15.9836 4.48438 15.0125 4.48438 13.9998V3.81814ZM9.57523 3.81814V13.9998C9.57523 14.3374 9.44114 14.6611 9.20246 14.8998C8.96378 15.1385 8.64006 15.2726 8.30251 15.2726C7.96497 15.2726 7.64125 15.1385 7.40257 14.8998C7.16389 14.6611 7.0298 14.3374 7.0298 13.9998V3.81814C7.0298 3.48059 7.16389 3.15688 7.40257 2.9182C7.64125 2.67952 7.96497 2.54543 8.30251 2.54543C8.64006 2.54543 8.96378 2.67952 9.20246 2.9182C9.44114 3.15688 9.57523 3.48059 9.57523 3.81814Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9391 14.0001C15.9388 15.8048 15.2997 17.5511 14.1349 18.9296C12.9701 20.308 11.3548 21.2295 9.5755 21.5308V25.4546H14.6663V28H1.93922V25.4546H7.03007V21.5308C5.25072 21.2295 3.63551 20.308 2.4707 18.9296C1.3059 17.5511 0.666735 15.8048 0.666504 14.0001V10.182H3.21193V14.0001C3.21193 15.3503 3.74829 16.6452 4.70301 17.5999C5.65773 18.5546 6.9526 19.091 8.30278 19.091C9.65296 19.091 10.9478 18.5546 11.9026 17.5999C12.8573 16.6452 13.3936 15.3503 13.3936 14.0001V10.182H15.9391V14.0001Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.adf94cbb570b2f570e3ce53688a13b2c.svg";
export { ForwardRef as ReactComponent };